<template>
  <div>
    <v-card>
           <v-app-bar class="transparent" light flat>
      <v-toolbar-title>
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon> </v-btn
        >Animateurs</v-toolbar-title
      >
    </v-app-bar>
      <v-card-title primary-title>
        Animateurs de la région {{ $route.params.region.ll_region }}
      </v-card-title>
      <v-card-text>
             <v-btn
              @click="dialog = !dialog"
              color="primary"
              dark
              class="ma-2"
              rounded
            >
              <v-icon left dark> mdi-plus-circle-outline </v-icon>Nouvel
              Utilisateur</v-btn
            >
        <ListUsers :identifiants="filterUsers($route.params.region.id)" />
      </v-card-text>
      <v-card-actions>
          <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
    ListUsers: require("@/components/ListUsers.vue").default,
  },
  created() {
    //this.GetUsersDeRegion(this.$route.params.region);
    this.GetIdentifiantsAll();
  },
  data() {
    return {
      usersFiltres: [],
    };
  },
  methods: {
    filterUsers(regionId) {
      //console.log("filterUsers:", regionId.toString());
      const filteredUserswithDistrict = [];

      _.forEach(this.usersDeRegion, function (userWithDistrict) {
        if (userWithDistrict.districts) {
          filteredUserswithDistrict.push(userWithDistrict);
        }
      });

      const filtered = filteredUserswithDistrict.filter((u) =>
        u.districts.some((d) => d.id_region === regionId.toString())
      );
      //console.log(filtered);
      return filtered;
      //return filteredUserswithDistrict;
    },
    ...mapActions({
      GetIdentifiantsAll: "Users/getAll",
    }),
  },
  computed: {
    ...mapState({
      usersDeRegion: (state) => state.Users.identifiants,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
